import {CloseToast, ErrorToast} from "@/components/VueToast";
import dropdownService from "@/api/Dropdown";
import router from "@/router";

export async function handleGoalChange(
    moduleId,
    newValue,
    dropdownId,
    dropdowns,
    goalNames,
    portalPrivateCoachingService,
) {
    try {
        const {data} = await portalPrivateCoachingService.getGoalsOnChangeModuleOrGoal(
            moduleId, newValue,
        );

        if (dropdownId !== 5) {
            goalNames[`goal${dropdownId}Name`].value = ''; // Initially reset selected goal name
        }

        // 6 is the last module dropdown
        if (data && dropdownId < 6) {
            // THE FIRST INDEX IN ARRAY IS 0 !!!!!!!!!!
            dropdowns[dropdownId].value =
                data?.data?.moduleGoals?.filter(item => item.shortName)
                    .map(item => ({
                        label: item.shortName,
                        value: item?.id,
                    }));


            // Assign the selected goal name to the appropriate goal state
            if (dropdownId !== 5) {
                if (data.data.selectedGoalName) {
                    goalNames[`goal${dropdownId}Name`].value = data.data.selectedGoalName; // Use .value for refs
                }
            }
        } else {
            goalNames[`goal${dropdownId}Name`].value = data.data.selectedGoalName;
        }

        //for (let i = dropdownId + 1; i < dropdowns.length; i++) {
        //    dropdowns[ i ].value = [];
        //    //goalNames[ `goal${i}Name` ].value = ''; // Reset goal name
        //    const goalNameKey    = `goal${i + 1}Name`;
        //
        //    // Check if the goal name exists and reset its value
        //    if (goalNames[ goalNameKey ]) {
        //        goalNames[ goalNameKey ].value = ''; // Reset goal name
        //    }
        //}
    } catch (error) {
        console.error('Error:', error);
    }
}

export async function handlePreviousMeetingGoalChange(
    moduleId,
    newValue,
    dropdownId,
    dropdowns,
    portalPrivateCoachingService,
) {
    try {
        const {data} = await portalPrivateCoachingService.getGoalsOnChangeModuleOrGoal(
            moduleId, newValue,
        );

        // 2 is the last module dropdown
        if (data && dropdownId < 2) {
            // THE FIRST INDEX IN ARRAY IS 0 !!!!!!!!!!
            dropdowns[dropdownId].value =
                data?.data?.moduleGoals?.filter(item => item.shortName)
                    .map(item => ({
                        label: item.shortName,
                        value: item?.id,
                    }));
        }

    } catch (error) {
        console.error('Error:', error);
    }
}

export const portalPrivateCoachingCheckModule = (data, formData, updateAsAdmin = false) => {
    const {
        maxUnitsForSection,
        sumUnitsDoneForSection,
        maxUnitsForModule,
        sumUnitsDoneForModule,
        editMeeting,
        unitsBeforeEdit,
        startDateRange,
        endDateRange,
    } = data.data;

    let errorMessage = '';
    let infoMessage = '';
    const formDataUnits = parseFloat(formData.value.units);


    // 1. FIRST CHECK UNITS ON MODULE LEVEL (PARENT LEVEL)
    if (maxUnitsForModule < sumUnitsDoneForModule) { // Units already done
        errorMessage =
            'Sie können dieses Modul nicht auswählen. ' +
            'Die maximale Anzahl von Einheiten (' +
            maxUnitsForModule +
            ') für dieses Modul wurde bereits abgeschlossen.';

        infoMessage = '';
    } else {
        if (unitsBeforeEdit !== formDataUnits) {
            const unitsLeftForModule = maxUnitsForModule - sumUnitsDoneForModule;
            if (unitsLeftForModule < formDataUnits) { // On change units in form
                errorMessage = `Sie können dieses Modul nicht auswählen. 
                Die maximale Anzahl von Einheiten (${maxUnitsForModule}) 
                für dieses Modul wurde bereits abgeschlossen.`;

                infoMessage = '';
            }
        }
    }

    // Return errors for the first section
    if (errorMessage !== '' || infoMessage !== '') {
        return [errorMessage, infoMessage];
    }

    // 2. SECOND, WE CHECK UNITS ON MODULE SECTION LEVEL
    let unitsLeftForSection;
    if (editMeeting) {
        unitsLeftForSection = Math.round(2 - ((sumUnitsDoneForSection - unitsBeforeEdit) + formDataUnits));
    } else {
        unitsLeftForSection = Math.round((2 - sumUnitsDoneForSection - formDataUnits) * 100) / 100;
    }

    if (unitsLeftForSection < 0) {
        errorMessage = 'Es kann maximal 1 Unterrichtseinheit eingetragen werden.';
        infoMessage = '';
    } else {

        if (updateAsAdmin) {
            infoMessage = `Für diesen Abschnitt des Moduls stehen Ihnen noch ${unitsLeftForSection} Einheiten zur Verfügung`;
        } else {
            infoMessage = `Für diesen Abschnitt des Moduls haben Sie ${unitsLeftForSection}.
                Die neu erstellten Sitzungsprotokolle müssen im Zeitraum vom
                ${startDateRange} bis ${endDateRange} liegen.`;
        }


        errorMessage = '';
    }

    return [errorMessage, infoMessage];
};


export function checkCoachingStartDateForMICV1(coachingData, coachingId) {
    if (coachingData) {
        const [day, month, year] = coachingData?.value.startDate.split('.'); // e.g., '2024-10-06'
        const coachingStartDate = `${year}-${month}-${day}`;
        const newLogicStartFrom = '2024-10-07'; // Target date in ISO format IMPORTANT !!!!!!!!

        if (Number(coachingId) !== 9950 && (coachingStartDate >= newLogicStartFrom)) {
            router.push({name: 'privateCoachingMicFirstInterviewV2Form', params: {coachingId}});
        }
    }
}

export function checkCoachingStartDateForMICV2(coachingData, coachingId) {
    if (coachingData.value) {
        const [day, month, year] = coachingData.value.startDate.split('.'); // e.g., '2024-10-06'
        const coachingStartDate = `${year}-${month}-${day}`;
        const newLogicStartFrom = '2024-10-07'; // Target date in ISO format IMPORTANT !!!!!!!!

        if (Number(coachingId) === 9950 || (coachingStartDate < newLogicStartFrom)) {
            router.push({name: 'privateCoachingMicFirstInterviewForm', params: {coachingId}});
        }
    }
}


export const mapData = (data, fields = ['id', 'title', 'description']) => {
    return data.map(item => {
        let mappedItem = {};
        fields.forEach(field => {
            mappedItem[field] = item[field] ?? null;
        });
        return mappedItem;
    });
};

export const generateHoursArray = (start, end) => {
    return Array.from({length: end - start + 1}, (_, i) => String(start + i).padStart(2, '0'));
};

export const generatePresenceRemainderAcceptanceDropdown = [
    {
        'value': 'Dies wurde vom Teilnehmenden abgelehnt',
        'label': 'Dies wurde vom Teilnehmenden abgelehnt',
    },
    {
        'value': 'Dies wurde vom Teilnehmenden angenommen',
        'label': 'Dies wurde vom Teilnehmenden angenommen',
    },
];

export function generateResourcesDropdown() {
    return [
        {label: 'Achtsamkeit im Alltag', value: 'Achtsamkeit im Alltag'},
        {label: 'aktive Vereinsmitgliedschaft', value: 'aktive Vereinsmitgliedschaft'},
        {
            label: 'Akzeptanz von nicht veränderbaren Fakten und/oder Situationen',
            value: 'Akzeptanz von nicht veränderbaren Fakten und/oder Situationen',
        },
        {label: 'Alltagskompetenz', value: 'Alltagskompetenz'},
        {label: 'Ausüben eines Ehrenamtes', value: 'Ausüben eines Ehrenamtes'},
        {label: 'Computerspiele spielen', value: 'Computerspiele spielen'},
        {label: 'Durchführen von Entspannungsmethoden', value: 'Durchführen von Entspannungsmethoden'},
        {label: 'Fahrradfahren', value: 'Fahrradfahren'},
        {label: 'Familienanbindung', value: 'Familienanbindung'},
        {label: 'Flexibilität im Denken', value: 'Flexibilität im Denken'},
        {label: 'Glaube oder Spiritualität', value: 'Glaube oder Spiritualität'},
        {label: 'gute Gesundheit', value: 'gute Gesundheit'},
        {label: 'gute Selbstwirksamkeitserwartung', value: 'gute Selbstwirksamkeitserwartung'},
        {label: 'hohe Resilienz', value: 'hohe Resilienz'},
        {label: 'Humor', value: 'Humor'},
        {label: 'Interesse an Kunst', value: 'Interesse an Kunst'},
        {label: 'Kreativität', value: 'Kreativität'},
        {label: 'Mobilität (z.B. Auto vorhanden)', value: 'Mobilität (z.B. Auto vorhanden)'},
        {label: 'Musik hören', value: 'Musik hören'},
        {label: 'Natur erleben', value: 'Natur erleben'},
        {label: 'Naturverbundenheit', value: 'Naturverbundenheit'},
        {label: 'Optimismus', value: 'Optimismus'},
        {label: 'regelmäßige Bewegung zum Ausgleich', value: 'regelmäßige Bewegung zum Ausgleich'},
        {label: 'regelmäßiger Sport', value: 'regelmäßiger Sport'},
        {label: 'soziale Kontakte', value: 'soziale Kontakte'},
        {label: 'Umgang mit Tieren', value: 'Umgang mit Tieren'},
        {label: 'vorhandenes Selbstvertrauen', value: 'vorhandenes Selbstvertrauen'},
        {label: 'Wissen in spezifischem Bereich', value: 'Wissen in spezifischem Bereich'},
    ];
}

export function generateProfessionalSkillsDropdown() {
    return [
        {
            label: 'Aktualisiertes Fachwissen aus Weiterbildungen',
            value: 'Aktualisiertes Fachwissen aus Weiterbildungen',
        },
        {label: 'Eigenständige Bewältigung von Aufgaben', value: 'Eigenständige Bewältigung von Aufgaben'},
        {label: 'Fachkenntnis in spezifischen Themen', value: 'Fachkenntnis in spezifischen Themen'},
        {
            label: 'Fundierte Kenntnis über typische Sachverhalte und Arbeitsabläufe',
            value: 'Fundierte Kenntnis über typische Sachverhalte und Arbeitsabläufe',
        },
        {label: 'Kenntnis der Fachsprache und Fachausdrücke', value: 'Kenntnis der Fachsprache und Fachausdrücke'},
        {
            label: 'Kenntnis rechtlicher Vorgaben im spezifischen Gebiet',
            value: 'Kenntnis rechtlicher Vorgaben im spezifischen Gebiet',
        },
        {
            label: 'Kompetente Einschätzung von Risiken und Gefahren',
            value: 'Kompetente Einschätzung von Risiken und Gefahren',
        },
        {label: 'Korrekter Einsatz von Arbeitsmitteln', value: 'Korrekter Einsatz von Arbeitsmitteln'},
        {
            label: 'Lösungskompetenz für den spezifischen Bereich',
            value: 'Lösungskompetenz für den spezifischen Bereich',
        },
        {
            label: 'Sachgemäßer Einsatz fachspezifischer Methoden',
            value: 'Sachgemäßer Einsatz fachspezifischer Methoden',
        },
    ];
}

export function generateCompetenciesDropdown() {
    return [
        {label: 'abgeschlossenes Studium', value: 'abgeschlossenes Studium'},
        {label: 'abgeschlossene Berufsausbildung', value: 'abgeschlossene Berufsausbildung'},
        {label: 'abgeschlossene Weiterbildungen', value: 'abgeschlossene Weiterbildungen'},
        {label: 'analytisches Denken', value: 'analytisches Denken'},
        {label: 'Berufserfahrung', value: 'Berufserfahrung'},
        {label: 'Dienstleistungsbewusstsein', value: 'Dienstleistungsbewusstsein'},
        {label: 'EDV-Kenntnisse', value: 'EDV-Kenntnisse'},
        {label: 'Effiziente Arbeitsweise', value: 'Effiziente Arbeitsweise'},
        {label: 'Eigenmotivation', value: 'Eigenmotivation'},
        {label: 'Ergebnisorientierung', value: 'Ergebnisorientierung'},
        {label: 'Fähigkeit zur Selbstmotivation', value: 'Fähigkeit zur Selbstmotivation'},
        {label: 'Führungsmanagement', value: 'Führungsmanagement'},
        {label: 'handwerkliches Geschick', value: 'handwerkliches Geschick'},
        {label: 'innovatives Denken', value: 'innovatives Denken'},
        {label: 'kognitive Fähigkeiten', value: 'kognitive Fähigkeiten'},
        {label: 'Kommunikationsstärke', value: 'Kommunikationsstärke'},
        {label: 'Kreativität', value: 'Kreativität'},
        {label: 'kritisches Denken', value: 'kritisches Denken'},
        {label: 'künstlerische Fähigkeiten', value: 'künstlerische Fähigkeiten'},
        {label: 'Leistungsbereitschaft', value: 'Leistungsbereitschaft'},
        {label: 'Lernbereitschaft', value: 'Lernbereitschaft'},
        {label: 'Lösungsorientierung', value: 'Lösungsorientierung'},
        {label: 'MS Office-Kenntnisse', value: 'MS Office-Kenntnisse'},
        {label: 'Organisationsfähigkeit', value: 'Organisationsfähigkeit'},
        {label: 'Praktikumserfahrung', value: 'Praktikumserfahrung'},
        {label: 'Professionalität', value: 'Professionalität'},
        {label: 'Programmierkenntnisse', value: 'Programmierkenntnisse'},
        {label: 'Risikobereitschaft', value: 'Risikobereitschaft'},
        {label: 'Sachlichkeit', value: 'Sachlichkeit'},
        {label: 'selbständiges Arbeiten', value: 'selbständiges Arbeiten'},
        {label: 'Softwarekenntnisse', value: 'Softwarekenntnisse'},
        {label: 'sprachliche Kompetenzen', value: 'sprachliche Kompetenzen'},
        {label: 'strategisches Denken', value: 'strategisches Denken'},
        {label: 'strukturiertes Arbeiten', value: 'strukturiertes Arbeiten'},
        {label: 'Teamfähigkeit', value: 'Teamfähigkeit'},
        {label: 'technische Fähigkeiten', value: 'technische Fähigkeiten'},
        {label: 'Zeitmanagement', value: 'Zeitmanagement'},
    ];
}

export function generateActionSkillsDropdown() {
    return [
        {label: 'Alltagskompetenz', value: 'Alltagskompetenz'},
        {label: 'Agilität', value: 'Agilität'},
        {label: 'Belastbarkeit', value: 'Belastbarkeit'},
        {label: 'Durchhaltevermögen', value: 'Durchhaltevermögen'},
        {label: 'Durchsetzungsfähigkeit', value: 'Durchsetzungsfähigkeit'},
        {label: 'Effizienz', value: 'Effizienz'},
        {label: 'Ergebnisorientierung', value: 'Ergebnisorientierung'},
        {label: 'Fähigkeit zur Selbstreflexion', value: 'Fähigkeit zur Selbstreflexion'},
        {label: 'Flexibilität', value: 'Flexibilität'},
        {label: 'Geduld', value: 'Geduld'},
        {label: 'Gestaltungswille', value: 'Gestaltungswille'},
        {label: 'Hands-On-Mentalität', value: 'Hands-On-Mentalität'},
        {label: 'Konfliktfähigkeit', value: 'Konfliktfähigkeit'},
        {label: 'Konsequenz im Handeln', value: 'Konsequenz im Handeln'},
        {label: 'Kontaktfreudigkeit', value: 'Kontaktfreudigkeit'},
        {label: 'Kooperationsbereitschaft', value: 'Kooperationsbereitschaft'},
        {label: 'Kritikfähigkeit', value: 'Kritikfähigkeit'},
        {label: 'Lernbereitschaft', value: 'Lernbereitschaft'},
        {label: 'Mediationstalent', value: 'Mediationstalent'},
        {label: 'Motivation', value: 'Motivation'},
        {label: 'Mut', value: 'Mut'},
        {label: 'Optimismus', value: 'Optimismus'},
        {label: 'Organisationsfähigkeit', value: 'Organisationsfähigkeit'},
        {label: 'Reflexionsfähigkeit', value: 'Reflexionsfähigkeit'},
        {label: 'Resilienz', value: 'Resilienz'},
        {label: 'Risikobereitschaft', value: 'Risikobereitschaft'},
        {label: 'Selbständigkeit', value: 'Selbständigkeit'},
        {label: 'Souveränität', value: 'Souveränität'},
        {label: 'Tatkraft', value: 'Tatkraft'},
        {label: 'Teamfähigkeit', value: 'Teamfähigkeit'},
        {label: 'Toleranz', value: 'Toleranz'},
        {label: 'Veränderungsbereitschaft', value: 'Veränderungsbereitschaft'},
        {label: 'Verantwortungsbewusstsein', value: 'Verantwortungsbewusstsein'},
        {label: 'Willensstärke', value: 'Willensstärke'},
        {label: 'Zeitmanagement', value: 'Zeitmanagement'},
        {label: 'Zielorientierung', value: 'Zielorientierung'},
    ];
}

export function generateCommunicativeSkillsDropdown() {
    return [
        {label: 'aktives Zuhören', value: 'aktives Zuhören'},
        {label: 'die Fähigkeit, andere zu motivieren', value: 'die Fähigkeit, andere zu motivieren'},
        {
            label: 'die Kompetenz, eigene Bedürfnisse auszudrücken',
            value: 'die Kompetenz, eigene Bedürfnisse auszudrücken',
        },
        {
            label: 'guten und verständlichen sprachlichen Ausdruck in deutscher Sprache',
            value: 'guten und verständlichen sprachlichen Ausdruck in deutscher Sprache',
        },
        {label: 'interkulturelle Kompetenz', value: 'interkulturelle Kompetenz'},
        {label: 'klare Kommunikation', value: 'klare Kommunikation'},
        {label: 'Kommunikationsstärke', value: 'Kommunikationsstärke'},
        {label: 'Konfliktlösungskompetenz', value: 'Konfliktlösungskompetenz'},
        {label: 'Konfliktmanagement', value: 'Konfliktmanagement'},
        {label: 'konstruktive Kritikfähigkeit', value: 'konstruktive Kritikfähigkeit'},
        {label: 'Kundenorientierung', value: 'Kundenorientierung'},
        {label: 'Motivationsfähigkeit', value: 'Motivationsfähigkeit'},
        {label: 'respektvollen Umgang', value: 'respektvollen Umgang'},
        {label: 'sachliche Kommunikation', value: 'sachliche Kommunikation'},
        {label: 'Schlagfertigkeit', value: 'Schlagfertigkeit'},
        {label: 'Selbstreflexion', value: 'Selbstreflexion'},
        {label: 'souveränes Auftreten', value: 'souveränes Auftreten'},
        {label: 'Überzeugungsgeschick', value: 'Überzeugungsgeschick'},
        {label: 'Urteilsvermögen', value: 'Urteilsvermögen'},
        {label: 'Verhandlungsgeschick', value: 'Verhandlungsgeschick'},
        {label: 'wertschätzenden Umgang', value: 'wertschätzenden Umgang'},
    ];
}

export function generateEmotionalSkillsDropdown() {
    return [
        {label: 'authentisch', value: 'authentisch'},
        {label: 'ehrlich', value: 'ehrlich'},
        {label: 'ein Familienmensch', value: 'ein Familienmensch'},
        {label: 'empathisch', value: 'empathisch'},
        {label: 'fähig zur Emotionsregulation', value: 'fähig zur Emotionsregulation'},
        {label: 'fähig zur Selbstfürsorge', value: 'fähig zur Selbstfürsorge'},
        {label: 'fürsorglich', value: 'fürsorglich'},
        {label: 'gelassen', value: 'gelassen'},
        {label: 'humorvoll', value: 'humorvoll'},
        {label: 'kinderlieb', value: 'kinderlieb'},
        {label: 'kritikfähig', value: 'kritikfähig'},
        {label: 'loyal', value: 'loyal'},
        {label: 'mitfühlend', value: 'mitfühlend'},
        {label: 'motiviert', value: 'motiviert'},
        {label: 'mutig', value: 'mutig'},
        {label: 'offen', value: 'offen'},
        {label: 'optimistisch', value: 'optimistisch'},
        {label: 'selbstbewusst', value: 'selbstbewusst'},
        {label: 'souverän', value: 'souverän'},
        {label: 'tierlieb', value: 'tierlieb'},
        {label: 'umgänglich', value: 'umgänglich'},
        {label: 'vertrauenswürdig', value: 'vertrauenswürdig'},
        {label: 'wertschätzend', value: 'wertschätzend'},
        {label: 'willensstark', value: 'willensstark'},
    ];
}

export function generateSocialSkillsDropdown() {
    return [
        {label: 'Belastbarkeit', value: 'Belastbarkeit'},
        {label: 'Eigeninitiative', value: 'Eigeninitiative'},
        {label: 'Eigenmotivation', value: 'Eigenmotivation'},
        {label: 'Einfühlungsvermögen', value: 'Einfühlungsvermögen'},
        {label: 'Fähigkeit zur Selbstreflexion', value: 'Fähigkeit zur Selbstreflexion'},
        {label: 'Fähigkeit, eigene Bedürfnisse auszudrücken', value: 'Fähigkeit, eigene Bedürfnisse auszudrücken'},
        {label: 'freundliches Auftreten', value: 'freundliches Auftreten'},
        {label: 'gute Menschenkenntnis', value: 'gute Menschenkenntnis'},
        {label: 'Hilfsbereitschaft', value: 'Hilfsbereitschaft'},
        {label: 'interkulturelle Kompetenz', value: 'interkulturelle Kompetenz'},
        {label: 'Kompromissbereitschaft', value: 'Kompromissbereitschaft'},
        {label: 'Kontaktfreudigkeit', value: 'Kontaktfreudigkeit'},
        {label: 'Kritikfähigkeit', value: 'Kritikfähigkeit'},
        {label: 'Lösungsorientierung', value: 'Lösungsorientierung'},
        {label: 'Loyalität', value: 'Loyalität'},
        {label: 'Mediationstalent', value: 'Mediationstalent'},
        {label: 'Offenheit', value: 'Offenheit'},
        {label: 'Selbstbewusstsein', value: 'Selbstbewusstsein'},
        {label: 'Selbstdisziplin', value: 'Selbstdisziplin'},
        {label: 'Souveränität', value: 'Souveränität'},
        {label: 'Stressresistenz', value: 'Stressresistenz'},
        {label: 'taktvolles Verhalten', value: 'taktvolles Verhalten'},
        {label: 'Teamfähigkeit', value: 'Teamfähigkeit'},
        {label: 'Toleranz', value: 'Toleranz'},
        {label: 'Umgänglichkeit', value: 'Umgänglichkeit'},
        {label: 'Verantwortungsbewusstsein', value: 'Verantwortungsbewusstsein'},
        {label: 'Vertrauen', value: 'Vertrauen'},
        {label: 'Zuverlässigkeit', value: 'Zuverlässigkeit'},
    ];
}

export async function getAssignedCoachesForDropdown(coachingId, coachDropdown) {
    try {
        CloseToast();
        const {data} = await dropdownService.getPrivateCoachingAssignedCoaches(+coachingId);

        coachDropdown.value = data.data.map(item => ({
            label: `${item.firstName}` + ' ' + `${item.lastName}`,
            value: item?.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export async function getAssignedModulesForDropdown(privateCoachingId, moduleDropdown) {
    try {
        CloseToast();
        const {data} = await dropdownService.getPrivateCoachingAssignedModules(+privateCoachingId);
        moduleDropdown.value = data.data.map(item => ({
            label: `${item.name}`,
            value: item?.id,
        }));
    } catch (error) {
        await ErrorToast(error);
    }
}

export function checkMissingMetingForSectionNumber(sectionNumberList, sectionNumber) {
    return !!sectionNumberList?.[sectionNumber];
}

export function canSeeSectionNumber(currentUserRole) {
    return currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'
}

export function canSeeMeetingHistory(currentUserRole) {
    return currentUserRole === 'ROLE_ADMIN'
}